@if (systemLayoutService.isReady()) {
    <adaa-period-slider
        [activePeriod]="selectedPeriod()!"
        [entityWeightsYears]="entityWeights()"
        type="quarter"
        [startDate]="isExternalOrParticipating() ? externalStartDate() : undefined"
        [endDate]="isExternalOrParticipating() ? externalEndDate() : undefined"
        (periodSelect)="selectPeriod($event)"
    />
}
@if (selectedPeriod(); as period) {
    <adaa-aggregated-performance [selectedPeriod]="period" [isPmo]="false" [aggregatedWeights]="aggregationWeights()">
        @if (hasKPIsWithIssue()) {
            <i
                class="fa fa-warning text-warning pointer"
                routerLink="/console/kpi/audit-issues"
                [title]="'landingPage.entity_page.kpi_issues' | translate"
            ></i>
        }
        {{ "landingPage.entity_page.performance_on" | translate }}
        <b>{{ aggregationTypeCardTitle() }}</b>
    </adaa-aggregated-performance>

    @if (!isExternalOrParticipating() && overallAggregationPerf(); as overallPerf) {
        @if (overallPerf.enabled) {
            <section class="position-relative d-block w-100 bg-card data-section">
                <div class="title">
                    <h4 class="fw-bold table-title" style="display: inline">
                        {{ "landingPage.entity_page.entity_overall_performance" | translate }}
                    </h4>
                </div>
                <adaa-entity-overall-performance
                    [entityId]="entity()!.id"
                    [periodId]="period.period.id"
                    [aggregationType]="overallPerf.aggregationType!"
                />
            </section>
        }
    }

    <adaa-ai-performance *adaaHasPermission="aiKpiPermission" [selectedPeriod]="period" />
}

@if (!isExternalOrParticipating()) {
    <section class="d-block w-100 position-relative mt-3 mb-2 px-3 pt-2 bg-card data-section shadow-none">
        @if (selectedPeriod()) {
            <adaa-data-table
                apiPrefix="item"
                apiName="getAllV2"
                [titleHeader]="'breadcrumbs.objectives.objectives' | translate"
                [configKey]="objectivesTableConf()"
                [paramsString]="objectivesParamString()"
                [enablePrint]="true"
                [enableAdd]="false"
                [enableEditAction]="false"
                [enableDeleteAction]="false"
                (actionClicked)="goToViewObjective($event.data)"
            />
        } @else {
            <div class="container w-100 d-flex justify-content-center py-3">
                <div class="zsk__loader zsk__loader--sm"></div>
            </div>
        }
    </section>
}

<section class="position-relative d-block w-100 bg-transparent shadow-none mt-4 mb-3">
    @if (selectedPeriod(); as period) {
        <adaa-government-enabler-pillars [period]="period" />
    } @else {
        <div class="container w-100 d-flex justify-content-center py-3">
            <div class="zsk__loader zsk__loader--sm"></div>
        </div>
    }
</section>

@if (!isExternalOrParticipating() && !isDsV2orV3() && selectedPeriod()) {
    <section class="d-block w-100 position-relative mt-3 mb-2 px-3 pt-2 bg-card data-section shadow-none">
        <adaa-data-table
            apiName="getInitiativeByIdAndPriorityV2"
            [paramsString]="highPriorityParamString()"
            [titleHeader]="'landingPage.highpriority.title' | translate"
            [configKey]="highPriorityInitiativesConf()"
            [enablePrint]="true"
            [enableAdd]="false"
            [enableEditAction]="false"
            [enableDeleteAction]="false"
            (actionClicked)="goToInitiatives($event.data)"
        />
    </section>
}

<section class="d-block w-100 position-relative mt-3 mb-4 px-3 pt-2 bg-card data-section shadow-none">
    <adaa-data-table
        #favoriteTable
        [apiName]="'getFavorites'"
        [titleHeader]="'landingPage.favorites.title' | translate"
        [configKey]="favoritesTableConf"
        [enablePrint]="true"
        [enableAdd]="false"
        [enableEditAction]="false"
        (actionClicked)="favoriteClicked($event)"
    ></adaa-data-table>
</section>
